export class LoadStopOptions {
  showCompleteAddress: boolean;
  showContacts: boolean;
  showReferenceTypes: boolean;
}
